import { withJsonFormsControlProps } from "@jsonforms/react";
import SwitchField from "./SwitchField";

const SwitchComponent = (props) => {
  const {
    handleChange,
    label,
    data,
    path,
    errors,
    schema,
    uischema,
    required,
    enabled,
    visible,
  } = props;

  if (!visible) return null;

  const isInverted = uischema?.options?.isInverted || false;

  const updateValue = (val) => {
    handleChange(path, isInverted ? !val : val);
  };

  return (
    <SwitchField
      value={isInverted ? !data : data}
      label={label}
      updateValue={updateValue}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
      disabled={!enabled}
    />
  );
};

export const SwitchControl = withJsonFormsControlProps(SwitchComponent);
